var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8984 5.78906C12.0156 5.78906 12.1328 5.75 12.25 5.75C14.3203 5.75 16 7.42969 16 9.5C16 11.5703 14.3203 13.25 12.25 13.25C10.1406 13.25 8.5 11.5703 8.5 9.5C8.5 9.42188 8.5 9.30469 8.5 9.1875C8.85156 9.38281 9.28125 9.5 9.75 9.5C11.1172 9.5 12.25 8.40625 12.25 7C12.25 6.57031 12.0938 6.14062 11.8984 5.78906ZM19.75 3.91406C21.5859 5.59375 22.7969 7.625 23.3828 9.03125C23.5 9.34375 23.5 9.69531 23.3828 10.0078C22.7969 11.375 21.5859 13.4062 19.75 15.125C17.9141 16.8438 15.375 18.25 12.25 18.25C9.08594 18.25 6.54688 16.8438 4.71094 15.125C2.875 13.4062 1.66406 11.375 1.07812 10.0078C0.960938 9.69531 0.960938 9.34375 1.07812 9.03125C1.66406 7.625 2.875 5.59375 4.71094 3.91406C6.54688 2.19531 9.08594 0.75 12.25 0.75C15.375 0.75 17.9141 2.19531 19.75 3.91406ZM12.25 3.875C9.125 3.875 6.625 6.41406 6.625 9.5C6.625 12.625 9.125 15.125 12.25 15.125C15.3359 15.125 17.875 12.625 17.875 9.5C17.875 6.41406 15.3359 3.875 12.25 3.875Z",
    fill: "#00AAC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsEye);
export default __webpack_public_path__ + "static/media/icons_eye.6a660655.svg";
export { ForwardRef as ReactComponent };